exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2x-C9{padding-top:10px;height:100px}._2x-C9,.HUHE4{max-width:400px}.HUHE4{padding:0;height:80px}._23STk{max-width:420px;margin-left:0}._23STk ._3CEPm{margin-top:20px!important;margin-bottom:0!important}._23STk ._3CEPm h3{display:inline-block;font-size:1.2em;margin:0}._23STk .xpIz5{background-color:#fff}.subIe{border-bottom:3px solid #00dcb2!important;border-right:3px solid #00dcb2!important;background-color:rgba(0,220,178,.1)!important}._2Hcbs{border-bottom:3px solid #dc0000!important;border-right:3px solid #dc0000!important;background-color:rgba(220,0,0,.5)!important}._3tsx5{background-color:#fff;box-shadow:0 2px 4px rgba(0,0,0,.1);padding:20px;transition:transform .2s}.dH-YV{margin-top:20px}._3oYD2{max-width:100%;padding:20px;display:grid;grid-template-columns:1fr;border:1px solid #9e9e9e}", ""]);

// exports
exports.locals = {
	"teal": "#00dcb2",
	"grey": "#b4b4b4",
	"orange": "#ff4e32",
	"sick": "#673ab7",
	"vacation": "#cddc39",
	"holiday": "#4caf50",
	"chartWrapper": "_2x-C9",
	"workCategoryCharts": "HUHE4",
	"totalChart": "_23STk",
	"ratioHeader": "_3CEPm",
	"ratioContent": "xpIz5",
	"underMinimum": "subIe",
	"overMaximum": "_2Hcbs",
	"card": "_3tsx5",
	"usersContainer": "dH-YV",
	"cardsContainer": "_3oYD2"
};